import SchoolyearPlanningActivities from "../views/schooladmin/SchoolyearPlanningActivities";
import SchoolyearPlanningActivitiesAddEdit from "../views/schooladmin/SchoolyearPlanningActivitiesAddEdit";

export default [
	{
		path: "/schooladmin/schoolyear_planning_activities",
		meta: { requiresPortalAdmin: true },
		components: {
			content: SchoolyearPlanningActivities
		}
	},
	{
		path: "/schooladmin/schoolyear_planning_activities/new",
		meta: { requiresPortalAdmin: true },
		components: {
			content: SchoolyearPlanningActivitiesAddEdit
		}
	},
	{
		path: "/schooladmin/schoolyear_planning_activities/update/:id",
		meta: { requiresPortalAdmin: true },
		components: {
			content: SchoolyearPlanningActivitiesAddEdit
		},
		props: {
			content: true
		}
	}
];
